import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Constants } from "../../../endPoints";
import { jwtDecode } from "jwt-decode";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

export default function Newproducts() {
  const [newArrivalProducts, setNewArrivalProducts] = useState([]);
  const [userId, setUserId] = useState(null);

  useEffect(() => {
    const fetchNewArrivals = async () => {
      try {
        let uid = null;
        const token = localStorage.getItem("authToken");
        if (token) {
          const decoded = jwtDecode(token);
          uid = decoded.id;
          setUserId(uid);
        }

        const [productsRes, wishlistRes] = await Promise.all([
          axios.get(Constants.getNewArrivalProducts),
          uid
            ? axios.get(`${Constants.getUserWishlist}/${uid}`)
            : Promise.resolve({ data: { list: [] } }),
        ]);

        const products = productsRes.data.list || productsRes.data.data || [];
        const wishlist = wishlistRes.data.list || [];
        const wishlistIds = wishlist.map((item) => item.idProduct);

        const merged = products.map((p) => ({
          ...p,
          isWishlist: wishlistIds.includes(p.id),
        }));

        setNewArrivalProducts(merged);
      } catch (error) {
        console.error("Error fetching products or wishlist:", error.message);
      }
    };

    fetchNewArrivals();
  }, []);

  const toggleWishlist = async (productId, isWished) => {
    if (!userId) return alert("Please log in to manage wishlist.");

    try {
      if (isWished) {
        await axios.delete(`${Constants.deleteFromWishlist}/${productId}`, {
          data: { idUser: userId },
        });
      } else {
        await axios.post(Constants.addToWishlist, {
          idUser: userId,
          idProduct: productId,
        });
      }

      setNewArrivalProducts((prev) =>
        prev.map((item) =>
          item.id === productId ? { ...item, isWishlist: !isWished } : item
        )
      );
    } catch (err) {
      console.error("Error updating wishlist:", err.message);
    }
  };

  return (
    <div className="arrivalSec">
      <div className="container">
        <div className="pagehding">
          <h2>New Arrivals</h2>
          <Link to="/listing" className="allLink">
            Shop New Arrivals
          </Link>
        </div>

        <div className="arrivalSlder">
          <div className="clientSlder">
            <Swiper
              modules={[Autoplay]}
              autoplay={{ delay: 2000, disableOnInteraction: false }}
              loop
              spaceBetween={20}
              slidesPerView={4}
              breakpoints={{
                0: { slidesPerView: 2, spaceBetween: 10 },
                480: { slidesPerView: 2, spaceBetween: 10 },
                768: { slidesPerView: 3, spaceBetween: 15 },
                992: { slidesPerView: 4, spaceBetween: 20 },
                1200: { slidesPerView: 4, spaceBetween: 30 },
              }}
              className="swiper-container"
            >
              {newArrivalProducts.map((product) => (
                <div className="swiper-wrapper">
                  <SwiperSlide key={product.id} className="swiper-slide">
                    <div className="productItem">
                      <div className="productimg">
                        <Link
                          to={`/details/${product.id}`}
                          className="showProduct"
                        >
                          <img
                            src={product.imageWithUrl}
                            alt={product.selectionName}
                          />
                        </Link>

                        <Link
                          to={`/details/${product.id}`}
                          className="onProduct"
                        >
                          <img
                            src={product.imageWithUrl}
                            alt={product.selectionName}
                          />
                        </Link>

                        <ul className="productlink">
                          <li>
                            <a
                              onClick={() =>
                                toggleWishlist(product.id, product.isWishlist)
                              }
                            >
                              <img
                                src={`${process.env.PUBLIC_URL}/assets/images/heart.svg`}
                                alt="Wishlist"
                                style={{
                                  filter: product.isWishlist
                                    ? "invert(18%) sepia(97%) saturate(7491%) hue-rotate(357deg)"
                                    : "none",
                                }}
                              />
                            </a>
                          </li>
                          {/* <li>
                            <Link to={`/details/${product.id}`}>
                              <img src={`${process.env.PUBLIC_URL}/assets/images/cart.svg`} alt="Cart" />
                            </Link>
                          </li> */}
                        </ul>
                      </div>

                      <div className="productCot">
                        <h3>{product.selectionName}</h3>
                        <span>Category:{" "} {product.categoryName}</span>
                        {/* <span>
                          $
                          {product.priceMin && product.priceMax
                            ? `${product.priceMin} – ${product.priceMax}`
                            : product.price}
                        </span> */}
                      </div>
                    </div>
                  </SwiperSlide>
                </div>
              ))}
            </Swiper>
          </div>
        </div>
      </div>
    </div>
  );
}
